import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { SolutionAdvisorDispatch, SolutionAdvisorState } from './store';

export const useSolutionAdvisorDispatch = (): SolutionAdvisorDispatch =>
  useDispatch<SolutionAdvisorDispatch>();
export const useSolutionAdvisorSelector: TypedUseSelectorHook<SolutionAdvisorState> =
  useSelector;
